// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentType, type ComponentProps } from 'react';
import noop from 'lodash/noop';
import { PopupIntegrationDI } from '@atlassian/jira-atlassian-switcher-common-integration-view';
import {
	AtlassianSwitcherIntegration as AtlassianSwitcherIntegrationDI,
	type AtlassianSwitcherIntegrationProps,
} from '@atlassian/jira-atlassian-switcher-integration';
import type { IntegrationViewRendererProps } from '@atlassian/jira-atlassian-switcher-integration/src/types';
import { TenantContextSubscriber as TenantContextSubscriberDI } from '@atlassian/jira-tenant-context-controller';

type Props = {
	isOpen: boolean;
	AtlassianSwitcherIntegration?: ComponentType<AtlassianSwitcherIntegrationProps>;
	IntegrationViewRenderer?: ComponentType<IntegrationViewRendererProps>;
	TenantContextSubscriber?: ComponentType<
		JSX.LibraryManagedAttributes<
			typeof TenantContextSubscriberDI,
			ComponentProps<typeof TenantContextSubscriberDI>
		>
	>;
	onClose: () => void;
	onOpen: () => void;
};

export const AppSwitcher = ({
	AtlassianSwitcherIntegration = AtlassianSwitcherIntegrationDI,
	isOpen,
	onClose,
	onOpen,
	IntegrationViewRenderer = PopupIntegrationDI,
	TenantContextSubscriber = TenantContextSubscriberDI,
}: Props) => (
	<TenantContextSubscriber>
		{({ tenantContext }) => {
			if (!tenantContext) return null;
			return (
				<AtlassianSwitcherIntegration
					isOpen={isOpen}
					onOpen={onOpen}
					onClose={onClose}
					onCloseComplete={noop}
					TenantContextSubscriber={TenantContextSubscriber}
					IntegrationViewRenderer={IntegrationViewRenderer}
				/>
			);
		}}
	</TenantContextSubscriber>
);

export default AppSwitcher;
